import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './custom-toast.css'; 

const Toast = () => (
  <ToastContainer
    position="bottom-right"
    autoClose={1000}
    hideProgressBar={true}
    newestOnTop={true}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
  />
);

const notify = (type = 'success', message) => {
  const defaultMessages = {
    success: 'Operation successful!',
    warning: 'Please be cautious!',
    error: 'Something went wrong!',
  };

  const displayMessage = message || defaultMessages[type];

  switch (type) {
    case 'success':
      toast.success(displayMessage, { className: 'success-toast custom-toast' });
      break;
    case 'warning':
      toast.warn(displayMessage, { className: 'warning-toast custom-toast' });
      break;
    case 'error':
      toast.error(displayMessage, { className: 'error-toast custom-toast' });
      break;
    default:
      toast(displayMessage);
      break;
  }
};

export { Toast, notify };
